export default __webpack_public_path__ + "static/media/3.e7b99d08.jpg";